import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { SelectItem } from "primeng/api";
import { PerfilCrezcamosService } from "../../../_services/perfil-crezcamos.service";
import { NavService } from "../../../_services/_nav.service";
import { Funcionalidad } from "../../../_models/funcionalidad";
import { Router } from "@angular/router";
import { DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
  selector: "app-perfil-crezcamos-buscador-tercero",
  templateUrl: "./perfil-crezcamos-buscador-tercero.component.html",
  styleUrls: ["./perfil-crezcamos-buscador-tercero.component.scss"],
})
export class PerfilCrezcamosBuscadorTerceroComponent implements OnInit {
  @Output() informacionTercero: EventEmitter<any> = new EventEmitter<any>();
  @Output() errorConsulta: EventEmitter<any> = new EventEmitter<any>();
  @Input() error: boolean;
  @Input() lisTiposDocumentos: SelectItem[] = [];

  loading = true;
  formulario: FormGroup;
  submitted = false;

  private menu: Funcionalidad[] = [];
  permisoSimulado: boolean = false;

  constructor(
    private fb: FormBuilder,
    private perfilcrezcamosService: PerfilCrezcamosService,
    private navService: NavService,
    private router: Router,
    private ref: DynamicDialogRef
  ) {}

  async ngOnInit(): Promise<void> {
    this.cargarFormulario();
    this.limpiarFormulario();
    this.permisoSimulado = await this.validarPermiso()
    this.loading = false;
  }

  private cargarFormulario(): void {
    this.formulario = this.fb.group({
      idTipoDocumento: [null, Validators.required],
      numeroDocumento: [null, Validators.required],
    });
  }

  get fControls() {
    return this.formulario.controls;
  }

  limpiarFormulario(): void {
    this.formulario.reset();
    this.submitted = false;
  }

  validarCampo(campo: string): void {
    const control = this.fControls[campo];
    const valor = Number(control.value);
    if (valor <= 0) {
      control.setValue(null);
    }
  }

  obtenerMenus() {
    const menus = localStorage.getItem("menu");
    if (menus !== null) {
      this.menu = JSON.parse(menus);
    } else {
      this.menu = [];
    }
    return this.menu;
  }

  findItemWithCodeAndChild(items, parentCode, childCode) {
    // Función auxiliar para buscar recursivamente en los hijos
    function findChild(item, childCode) {
      if (!item.hijos) return false;
      return item.hijos.some((hijo) => hijo.codigo === childCode);
    }

    // Recorrer el array principal
    for (let item of items) {
      if (item.codigo === parentCode && findChild(item, childCode)) {
        return true;
      }
    }
    return false;
  }

  async validarPermiso() {
    const funcionalidades = this.obtenerMenus();
    const validacion = this.findItemWithCodeAndChild(
      funcionalidades,
      "MODHER",
      "SIMCRE"
    );
    return validacion;
  }

  redireccionar(url: string = "") {
    if (url) {
      this.router.navigate([url], { replaceUrl: true });
      this.ref.close();
    }
  }

  async onSubmit(): Promise<void> {
    this.submitted = true;

    if (this.formulario.invalid) {
      console.warn("Formulario inválido");
      return;
    }

    this.loading = true;

    try {
      const { idTipoDocumento, numeroDocumento } =
        this.formulario.getRawValue();
      const respuesta = await this.perfilcrezcamosService
        .buscarTercero({
          codigoTipoDocumento: idTipoDocumento,
          numeroDocumento,
        })
        .toPromise();

      if (!respuesta) {
        this.errorConsulta.emit(true);
        this.limpiarFormulario();
      } else if (respuesta?.mensaje) {
        this.mostrarMensaje("info", "LBL_INFORMACION", respuesta.mensaje);
      } else {
        this.errorConsulta.emit(false);
        this.informacionTercero.emit({ ...respuesta, codigoTipoDocumento: idTipoDocumento });
      }
    } catch (error) {
      console.error("Error al realizar la búsqueda:", error);
      this.errorConsulta.emit(true);
    } finally {
      this.loading = false
    }
  }

  mostrarMensaje(
    severity: string,
    summary: string,
    detail: string
  ) {
    this.navService.setMesage(0, {
      severity,
      summary: this.navService.buscarMensaje(summary),
      detail: this.navService.buscarMensaje(detail),
    });
  }

  regresar() {
    this.limpiarFormulario();
    this.errorConsulta.emit(false);
  }
}
